module.exports = __webpack_public_path__ + "img/lemon-right-6.7cb57f46.png";